/**
 * Fields the contract items API can sort by, as sent to the API. Delivered and
 * pending totals and derived prices are not sortable.
 */
export const CONTRACT_ITEM_SORT_FIELDS = [
  'position',
  'product_name',
  'seller_article_id',
  'buyer_article_id',
  'manufacturer',
  'unit_type',
  'gross_price',
  'quantity_ordered',
  'created_on',
  'modified_on',
] as const;
